// Temporary cookie bridge for Vendor Connect (test only).
//
// Vendor Connect backend expects these cookies (see vendor-app-backend VendorsService):
// - vendor_session_idtoken
// - vendor_session_accesstoken
// - vendor_session_buss_name
//
// NOTE:
// - This is intentionally frontend-set (NOT HttpOnly) as a temporary shim.
// - Restricting to pearl-test and localhost to avoid unintended prod impact.
/* eslint-disable no-console */
const COOKIE_DOMAIN = '.davidsbridal.com';
const COOKIE_PATH = '/';
const DEFAULT_MAX_AGE_SECONDS = 60 * 60 * 8; // 8 hours

function isPearlTestHost() {
    try {
        const host = window?.location?.hostname || '';
        // Covers pearl-test, pearl-test-admin, any test subdomains, and localhost for development.
        return host.includes('pearl-test') || host === 'localhost' || host === '127.0.0.1';
    } catch {
        return false;
    }
}

function setCookie(name, value, opts = {}) {
    const {
        domain = COOKIE_DOMAIN,
        path = COOKIE_PATH,
        maxAgeSeconds = DEFAULT_MAX_AGE_SECONDS,
        sameSite = 'None',
        secure = true,
    } = opts;

    if (!name) return;

    // Encode to keep JWTs/spaces safe in cookie value.
    const encodedValue = encodeURIComponent(value ?? '');

    const parts = [`${name}=${encodedValue}`, `Path=${path}`, `Max-Age=${maxAgeSeconds}`];

    // Only set Domain for non-localhost hosts (cookies on localhost don't need/want a domain)
    const hostname = window?.location?.hostname || '';
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

    if (!isLocalhost) {
        parts.push(`Domain=${domain}`);
    }

    // For localhost, use 'Lax' instead of 'None' and don't require Secure
    if (isLocalhost) {
        parts.push(`SameSite=Lax`);
    } else {
        parts.push(`SameSite=${sameSite}`);
        if (secure) parts.push('Secure');
    }

    document.cookie = parts.join('; ');
}

export function setVendorConnectSessionCookies({
    idToken,
    accessToken,
    refreshToken,
    businessName,
}) {
    if (!isPearlTestHost()) {
        return false;
    }

    if (!idToken || !accessToken) {
        // If these are missing, Vendor Connect cannot identify the vendor.
        console.warn('[vendorconnect] Missing idToken/accessToken; not setting cookies.');
        return false;
    }

    setCookie('vendor_session_idtoken', idToken);
    setCookie('vendor_session_accesstoken', accessToken);
    setCookie('vendor_session_buss_name', businessName || '');

    // Vendor Connect BE logout currently clears vendor_session_refreshtoken.
    // Setting it keeps logout behavior consistent (even if Vendor Connect BE doesn't read it).
    if (refreshToken) {
        setCookie('vendor_session_refreshtoken', refreshToken);
    }

    return true;
}
